import type { IPopupContext, IPopupViewModel } from '../../services/i-popup-service';
import type { LocalizedString } from '../../dto/localized-string';

export interface PaywallPopupOptions {
	readonly message: LocalizedString;
	readonly buyMeCoffeeUrl: string;
	readonly useTelegramPayment: boolean;
}

export class PaywallPopupViewModel implements IPopupViewModel<null> {
	public readonly popupId = 'paywall' as const;

	public readonly message: LocalizedString;
	public readonly buyMeCoffeeUrl: string;
	public readonly useTelegramPayment: boolean;

	private ctx: IPopupContext<null> | null = null;

	public constructor(options: PaywallPopupOptions) {
		this.message = options.message;
		this.buyMeCoffeeUrl = options.buyMeCoffeeUrl;
		this.useTelegramPayment = options.useTelegramPayment;
	}

	public init(context: IPopupContext<null>): void {
		this.ctx = context;
	}

	/**
	 * Paywall is intentionally non-dismissible via the popup shell (ESC / close button).
	 * The host should ignore close requests for this popupId.
	 */
	public handleClose(): void {
		// no-op
	}

	public closeAfterPurchase(): void {
		this.ctx?.closePopup(null);
	}

	public cancel(): void {
		this.ctx?.cancelPopup(null);
	}
}


